import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageHero from './PageHero';

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { t } = useTranslation();

  return (
    <div className="terms-page">
      <PageHero title={t('terms_title')} />
      <div className="container" style={{ padding: '40px 0' }}>
        <section className="fade-up">
          <h2>{t('terms_accept_title')}</h2>
          <p>{t('terms_accept_body')}</p>
        </section>
        <section className="fade-up stagger-1">
          <h2>{t('terms_use_title')}</h2>
          <p>{t('terms_use_body')}</p>
        </section>
        <section className="fade-up stagger-2">
          <h2>{t('terms_changes_title')}</h2>
          <p>{t('terms_changes_body')}</p>
        </section>
        <section className="fade-up stagger-3">
          <h2>{t('terms_contact_title')}</h2>
          <p>{t('terms_contact_body')}</p>
        </section>
      </div>
    </div>
  );
};

export default Terms;
